<!--
 * @Descripttion:
 * @Version: 1.0
 * @Author: +C
 * @Date: 2022-02-17 15:03:41
 * @LastEditors: wufz
 * @LastEditTime: 2023-01-09 17:13:18
-->
<template>
  <vxe-input ref="xInput" v-if="!isDetail" v-bind="$attrs" v-on="$listeners">
  </vxe-input>
  <span v-else>{{ $attrs.value }} </span>
</template>

<script>
import formComponents from "./formComponents"
export default {
  name: 'DxxInput',
  //页面引用的组件
  components: {},
  //继承表单父组件
  extends: formComponents,
  //父页面传递参数
  props: {},
  data() {
    return {};
  },
  //监控计算变量
  computed: {},
  //监听
  watch: {},
  //页面的构造方法
  created() { },
  //父页面定义方法给子页面inject调用
  provide() { return {} },
  //子组件调用注入到父页面providee
  inject: [],
  //dom加载完
  mounted() {
    //动态绑定vxetable的函数到this
    for (let key in this.$refs.xInput) {
      if (typeof this.$refs.xInput[key] === "function") {
        this[key] = this.$refs.xInput[key]
      }
    }
  },
  //页面的自定义方法
  methods: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/input.vue